module.exports = __webpack_public_path__ + "media/packs/images/flags/PG-eb9ce28bb5715d3d2e5ca9452127a996.png";